export const ROLES = [
	'Admin',
	'Agrupament',
	'Unitat',
	'Familiar',
	'Excaps',
	'Caps',
	'Tresoreria',
] as const;
export type Role = (typeof ROLES)[number];

// Roles that can see the Factures section (must mirror back/src/constants/finance.ts)
export const FACTURES_VIEW_ROLES = [
	'Admin',
	'Agrupament',
	'Unitat',
	'Caps',
	'Tresoreria',
] as const;

// Roles that can move money (mensual/ajust/reimburse/edit reimbursed)
export const FINANCES_MONEY_ROLES = ['Admin', 'Tresoreria'] as const;

export const FACTURES_UNITATS = [
	{ id: 'cills', nom: 'Castors i Llúdrigues' },
	{ id: 'llids', nom: 'LLiDs' },
	{ id: 'rings', nom: 'RiNGs' },
	{ id: 'pics', nom: 'PiCs' },
	{ id: 'trucs', nom: 'TRUCs' },
] as const;